import Article from './ArticleCard';
import Carousel from './CarouselCard';
import Podcast from './PodcastCard';
import Static from './StaticCard';
import Story from './StoryCard';

export const contentCardMap = {
  ContentfulArticleList: Article,
  ContentfulArticleLongForm: Article,
  ContentfulArticlePodcast: Podcast,
  ContentfulCarouselSnippetsContentCard: Carousel,
  ContentfulStaticContentCard: Static,
  ContentfulStory: Story,
};
